<section #parentRef>
    <div class="image-container">
        <xm-media-image aria-hidden="true" [imageOptions]="icon" class="icon"></xm-media-image>
    </div>
    <ng-container *ngIf="hasFieldOrEditable(rendering.fields.header)">
        <h2 class="header" *scRichText="rendering.fields.header"></h2>
    </ng-container>
    <ng-container *ngIf="hasFieldOrEditable(rendering.fields.title)">
        <div class="title" *scRichText="rendering.fields.title"></div>
    </ng-container>
    <xm-cms-text *ngIf="hasFieldOrEditable(rendering.fields.body)" class="body" [field]="rendering.fields.body"></xm-cms-text>
    <div class="data-options-container btgb-container">
        <div class="data-options btg-options"  *ngIf="hasFieldOrEditable(rendering.fields.btgPlanSizeOne) || hasFieldOrEditable(rendering.fields.btgPlanSizeOneSuffix) || hasFieldOrEditable(rendering.fields.btgPlanPriceOne)">
            <ng-container *ngIf="hasFieldOrEditable(rendering.fields.btgPlanSizeOne)">
                <span class="plan-size" *scRichText="rendering.fields.btgPlanSizeOne"></span>
            </ng-container>
            <ng-container *ngIf="hasFieldOrEditable(rendering.fields.btgPlanSizeOneSuffix)">
                <sup class="suffix" *scRichText="rendering.fields.btgPlanSizeOneSuffix"></sup>
            </ng-container>
            <ng-container *ngIf="hasFieldOrEditable(rendering.fields.btgPlanPriceOne)">
                <div class="plan-price" *scRichText="rendering.fields.btgPlanPriceOne"></div>
            </ng-container>
        </div>
        <div class="data-options btg-options" *ngIf="hasFieldOrEditable(rendering.fields.btgPlanSizeTwo) || hasFieldOrEditable(rendering.fields.btgPlanSizeTwoSuffix) || hasFieldOrEditable(rendering.fields.btgPlanPriceTwo)">
            <ng-container *ngIf="hasFieldOrEditable(rendering.fields.btgPlanSizeTwo)">
                <span class="plan-size" *scRichText="rendering.fields.btgPlanSizeTwo"></span>
            </ng-container>
            <ng-container *ngIf="hasFieldOrEditable(rendering.fields.btgPlanSizeTwoSuffix)">
                <sup class="header suffix" *scRichText="rendering.fields.btgPlanSizeTwoSuffix"></sup>
            </ng-container>
            <ng-container *ngIf="hasFieldOrEditable(rendering.fields.btgPlanPriceTwo)">
                <div class="plan-price" *scRichText="rendering.fields.btgPlanPriceTwo"></div>
            </ng-container>
        </div>
        <div class="data-options btg-options" *ngIf="hasFieldOrEditable(rendering.fields.btgPlanSizeThree) || hasFieldOrEditable(rendering.fields.btgPlanSizeThreeSuffix) || hasFieldOrEditable(rendering.fields.btgPlanPriceThree)">
            <ng-container *ngIf="hasFieldOrEditable(rendering.fields.btgPlanSizeThree)">
                <span class="plan-size" *scRichText="rendering.fields.btgPlanSizeThree"></span>
            </ng-container>
            <ng-container *ngIf="hasFieldOrEditable(rendering.fields.btgPlanSizeThreeSuffix)">
                <sup class="header suffix" *scRichText="rendering.fields.btgPlanSizeThreeSuffix"></sup>
            </ng-container>
            <ng-container *ngIf="hasFieldOrEditable(rendering.fields.btgPlanPriceThree)">
                <div class="plan-price" *scRichText="rendering.fields.btgPlanPriceThree"></div>
            </ng-container>
        </div>
        <div class="data-options btg-options" *ngIf="hasFieldOrEditable(rendering.fields.btgPlanSizeFour) || hasFieldOrEditable(rendering.fields.btgPlanSizeFourSuffix) || hasFieldOrEditable(rendering.fields.btgPlanPriceFour)">
            <ng-container *ngIf="hasFieldOrEditable(rendering.fields.btgPlanSizeFour)">
                <span class="plan-size" *scRichText="rendering.fields.btgPlanSizeFour"></span>
            </ng-container>
            <ng-container *ngIf="hasFieldOrEditable(rendering.fields.btgPlanSizeFourSuffix)">
                <sup class="header suffix" *scRichText="rendering.fields.btgPlanSizeFourSuffix"></sup>
            </ng-container>
            <ng-container *ngIf="hasFieldOrEditable(rendering.fields.btgPlanPriceFour)">
                <div class="plan-price" *scRichText="rendering.fields.btgPlanPriceFour"></div>
            </ng-container>
        </div>
        <div class="data-options btg-options" *ngIf="hasFieldOrEditable(rendering.fields.btgPlanSizeFive) || hasFieldOrEditable(rendering.fields.btgPlanSizeFiveSuffix) || hasFieldOrEditable(rendering.fields.btgPlanPriceFive)">
            <ng-container *ngIf="hasFieldOrEditable(rendering.fields.btgPlanSizeFive)">
                <span class="plan-size" *scRichText="rendering.fields.btgPlanSizeFive"></span>
            </ng-container>
            <ng-container *ngIf="hasFieldOrEditable(rendering.fields.btgPlanSizeFiveSuffix)">
                <sup class="header suffix" *scRichText="rendering.fields.btgPlanSizeFiveSuffix"></sup>
            </ng-container>
            <ng-container *ngIf="hasFieldOrEditable(rendering.fields.btgPlanPriceFive)">
                <div class="plan-price" *scRichText="rendering.fields.btgPlanPriceFive"></div>
            </ng-container>
        </div>
        <div class="data-options btg-options" *ngIf="hasFieldOrEditable(rendering.fields.btgPlanSizeSix) || hasFieldOrEditable(rendering.fields.btgPlanSizeSixSuffix) || hasFieldOrEditable(rendering.fields.btgPlanPriceSix)">
            <ng-container *ngIf="hasFieldOrEditable(rendering.fields.btgPlanSizeSix)">
                <span class="plan-size" *scRichText="rendering.fields.btgPlanSizeSix"></span>
            </ng-container>
            <ng-container *ngIf="hasFieldOrEditable(rendering.fields.btgPlanSizeSixSuffix)">
                <sup class="header suffix" *scRichText="rendering.fields.btgPlanSizeSixSuffix"></sup>
            </ng-container>
            <ng-container *ngIf="hasFieldOrEditable(rendering.fields.btgPlanPriceSix)">
                <div class="plan-price" *scRichText="rendering.fields.btgPlanPriceSix"></div>
            </ng-container>
        </div>
    </div>
    <div class="data-options-container">
        <div class="data-options" *ngIf="hasFieldOrEditable(rendering.fields.unlimitedPlanSizePrefix) || hasFieldOrEditable(rendering.fields.unlimitedPlanSize) || hasFieldOrEditable(rendering.fields.unlimitedPlanPrice)">
            <ng-container *ngIf="hasFieldOrEditable(rendering.fields.unlimitedPlanSizePrefix)">
                <sup class="header prefix" *scRichText="rendering.fields.unlimitedPlanSizePrefix"></sup>
            </ng-container>
            <ng-container *ngIf="hasFieldOrEditable(rendering.fields.unlimitedPlanSize)">
                <span class="plan-size" *scRichText="rendering.fields.unlimitedPlanSize"></span>
            </ng-container>
            <ng-container *ngIf="hasFieldOrEditable(rendering.fields.unlimitedPlanPrice)">
                <div class="plan-price" *scRichText="rendering.fields.unlimitedPlanPrice"></div>
            </ng-container>
        </div>
    </div>
    <div class="data-options-container">
        <div class="unlimited-data-options" 
        *ngIf="hasFieldOrEditable(rendering.fields.unlimitedPlanSizeOne) || hasFieldOrEditable(rendering.fields.unlimitedPlanPriceOne) ||
        hasFieldOrEditable(rendering.fields.unlimitedPlanSizeOneSuffix) || hasFieldOrEditable(rendering.fields.unlimitedPlanPriceOneSubtext) ||
        hasFieldOrEditable(rendering.fields.unlimitedPlanPriceOneTotal) || hasFieldOrEditable(rendering.fields.unlimitedPlanPriceOneTotalLabel)">
            <div class="plan-size-wrapper">
                <ng-container *ngIf="hasFieldOrEditable(rendering.fields.unlimitedPlanSizeOne)">
                    <span class="unlimited-plan-size" *scRichText="rendering.fields.unlimitedPlanSizeOne"></span>
                </ng-container>
                <ng-container *ngIf="hasFieldOrEditable(rendering.fields.unlimitedPlanSizeOneSuffix)">
                    <sup class="unlimited-line-suffix" *scRichText="rendering.fields.unlimitedPlanSizeOneSuffix"></sup>
                </ng-container>
            </div>
            <ng-container *ngIf="hasFieldOrEditable(rendering.fields.unlimitedPlanPriceOne)">
                <div class="unlimited-plan-price" *scRichText="rendering.fields.unlimitedPlanPriceOne"></div>
            </ng-container>
            <ng-container *ngIf="hasFieldOrEditable(rendering.fields.unlimitedPlanPriceOneSubtext)">
                <div class="plan-subtext" *scRichText="rendering.fields.unlimitedPlanPriceOneSubtext"></div>
            </ng-container>
            <ng-container *ngIf="hasFieldOrEditable(rendering.fields.unlimitedPlanPriceOneTotal)">
                <div class="plan-total" *scRichText="rendering.fields.unlimitedPlanPriceOneTotal"></div>
            </ng-container>
            <ng-container *ngIf="hasFieldOrEditable(rendering.fields.unlimitedPlanPriceOneTotalLabel)">
                <div class="plan-total-label" *scRichText="rendering.fields.unlimitedPlanPriceOneTotalLabel"></div>
            </ng-container>
        </div>
        <div class="unlimited-data-options" *ngIf="hasFieldOrEditable(rendering.fields.unlimitedPlanSizeTwo) || hasFieldOrEditable(rendering.fields.unlimitedPlanPriceTwo) || 
        hasFieldOrEditable(rendering.fields.unlimitedPlanSizeTwoSuffix) || hasFieldOrEditable(rendering.fields.unlimitedPlanPriceTwoSubtext) ||
        hasFieldOrEditable(rendering.fields.unlimitedPlanPriceTwoTotal) || hasFieldOrEditable(rendering.fields.unlimitedPlanPriceTwoTotalLabel)">
            <div class="plan-size-wrapper">
                <ng-container *ngIf="hasFieldOrEditable(rendering.fields.unlimitedPlanSizeTwo)">
                    <span class="unlimited-plan-size" *scRichText="rendering.fields.unlimitedPlanSizeTwo"></span>
                </ng-container>
                <ng-container *ngIf="hasFieldOrEditable(rendering.fields.unlimitedPlanSizeTwoSuffix)">
                    <sup class="unlimited-line-suffix" *scRichText="rendering.fields.unlimitedPlanSizeTwoSuffix"></sup>
                </ng-container>
            </div>
            <ng-container *ngIf="hasFieldOrEditable(rendering.fields.unlimitedPlanPriceTwo)">
                <div class="unlimited-plan-price" *scRichText="rendering.fields.unlimitedPlanPriceTwo"></div>
            </ng-container>
            <ng-container *ngIf="hasFieldOrEditable(rendering.fields.unlimitedPlanPriceTwoSubtext)">
                <div class="plan-subtext" *scRichText="rendering.fields.unlimitedPlanPriceTwoSubtext"></div>
            </ng-container>
            <ng-container *ngIf="hasFieldOrEditable(rendering.fields.unlimitedPlanPriceTwoTotal)">
                <div class="plan-total" *scRichText="rendering.fields.unlimitedPlanPriceTwoTotal"></div>
            </ng-container>
            <ng-container *ngIf="hasFieldOrEditable(rendering.fields.unlimitedPlanPriceTwoTotalLabel)">
                <div class="plan-total-label" *scRichText="rendering.fields.unlimitedPlanPriceTwoTotalLabel"></div>
            </ng-container>
        </div>
        <div class="unlimited-data-options" *ngIf="hasFieldOrEditable(rendering.fields.unlimitedPlanSizeThree) || hasFieldOrEditable(rendering.fields.unlimitedPlanSizeThreeSuffix) ||
        hasFieldOrEditable(rendering.fields.unlimitedPlanPriceThree) || hasFieldOrEditable(rendering.fields.unlimitedPlanPriceThreeSubtext) ||
        hasFieldOrEditable(rendering.fields.unlimitedPlanPriceThreeTotal) || hasFieldOrEditable(rendering.fields.unlimitedPlanPriceThreeTotalLabel)">
            <div class="plan-size-wrapper">
                <ng-container *ngIf="hasFieldOrEditable(rendering.fields.unlimitedPlanSizeThree)">
                    <span class="unlimited-plan-size" *scRichText="rendering.fields.unlimitedPlanSizeThree"></span>
                </ng-container>
                <ng-container *ngIf="hasFieldOrEditable(rendering.fields.unlimitedPlanSizeThreeSuffix)">
                    <sup class="unlimited-line-suffix" *scRichText="rendering.fields.unlimitedPlanSizeThreeSuffix"></sup>
                </ng-container>
            </div>
            <ng-container *ngIf="hasFieldOrEditable(rendering.fields.unlimitedPlanPriceThree)">
                <div class="unlimited-plan-price" *scRichText="rendering.fields.unlimitedPlanPriceThree"></div>
            </ng-container>
            <ng-container *ngIf="hasFieldOrEditable(rendering.fields.unlimitedPlanPriceThreeSubtext)">
                <div class="plan-subtext" *scRichText="rendering.fields.unlimitedPlanPriceThreeSubtext"></div>
            </ng-container>
            <ng-container *ngIf="hasFieldOrEditable(rendering.fields.unlimitedPlanPriceThreeTotal)">
                <div class="plan-total" *scRichText="rendering.fields.unlimitedPlanPriceThreeTotal"></div>
            </ng-container>
            <ng-container *ngIf="hasFieldOrEditable(rendering.fields.unlimitedPlanPriceThreeTotalLabel)">
                <div class="plan-total-label" *scRichText="rendering.fields.unlimitedPlanPriceThreeTotalLabel"></div>
            </ng-container>
        </div>
        <div class="unlimited-data-options" *ngIf="hasFieldOrEditable(rendering.fields.unlimitedPlanSizeFour) || hasFieldOrEditable(rendering.fields.unlimitedPlanSizeFourSuffix) || 
        hasFieldOrEditable(rendering.fields.unlimitedPlanPriceFour) || hasFieldOrEditable(rendering.fields.unlimitedPlanPriceFourSubtext) ||
        hasFieldOrEditable(rendering.fields.unlimitedPlanPriceFourTotal) || hasFieldOrEditable(rendering.fields.unlimitedPlanPriceFourTotalLabel)">
            <div class="plan-size-wrapper">
                <ng-container *ngIf="hasFieldOrEditable(rendering.fields.unlimitedPlanSizeFour)">
                    <span class="unlimited-plan-size" *scRichText="rendering.fields.unlimitedPlanSizeFour"></span>
                </ng-container>
                <ng-container *ngIf="hasFieldOrEditable(rendering.fields.unlimitedPlanSizeFourSuffix)">
                    <sup class="unlimited-line-suffix" *scRichText="rendering.fields.unlimitedPlanSizeFourSuffix"></sup>
                </ng-container>
            </div>
            <ng-container *ngIf="hasFieldOrEditable(rendering.fields.unlimitedPlanPriceFour)">
                <div class="unlimited-plan-price" *scRichText="rendering.fields.unlimitedPlanPriceFour"></div>
            </ng-container>
            <ng-container *ngIf="hasFieldOrEditable(rendering.fields.unlimitedPlanPriceFourSubtext)">
                <div class="plan-subtext" *scRichText="rendering.fields.unlimitedPlanPriceFourSubtext"></div>
            </ng-container>
            <ng-container *ngIf="hasFieldOrEditable(rendering.fields.unlimitedPlanPriceFourTotal)">
                <div class="plan-total" *scRichText="rendering.fields.unlimitedPlanPriceFourTotal"></div>
            </ng-container>
            <ng-container *ngIf="hasFieldOrEditable(rendering.fields.unlimitedPlanPriceFourTotalLabel)">
                <div class="plan-total-label" *scRichText="rendering.fields.unlimitedPlanPriceFourTotalLabel"></div>
            </ng-container>
        </div>
    </div>
    <div>
        <xm-generic-link class="bottom-link" *ngIf="hasFieldOrEditable(rendering.fields.linkDecorationOne)" [field]="rendering.fields.linkDecorationOne"></xm-generic-link>
    </div>
    <xm-cms-text *ngIf="hasFieldOrEditable(rendering.fields.bottomSubtext)" class="bottom-subtext" [field]="rendering.fields.bottomSubtext"></xm-cms-text>
    <div *ngIf="hasPlaceholder(rendering, 'unlPricingModal')">
        <div sc-placeholder name="unlPricingModal" [rendering]="rendering"></div>
    </div>
    <xm-popover
    *ngIf="rendering.fields.popover"
    class="popover-button"
    [rendering]="rendering.fields.popover"
    [parentTemplate]="parentRef"
    [customClass]="'planPage'"
    position="center">
</xm-popover>
</section>
